import React, { useState } from 'react';

import { ReactComponent as LoginMailIcon } from '../../assets/images/loginMailIcon.svg';
import s10Logo from '../../assets/images/s10Logo.png';
import authImage from '../../assets/images/auth.png';

import { Button, Grid, InputAdornment, Typography, Divider, Modal, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MyTextField from '../../components/MyTextField';

import validationSchema from '../../schemas/login.schema';
import { useFormik } from 'formik';
import MySnackbar from '../../components/MySnackbar';
import { Link, useNavigate } from 'react-router-dom';
import { recoverPasswordRequest } from '../../api/authApi';

const PasswordRecoveryModal = ({ success }: any) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(success);

  const handleClose = () => {
    setOpen(false);
    navigate('/ingresar')
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography id="modal-title" variant="h6" component="h2" gutterBottom>
          Correo enviado exitosamente
        </Typography>
        <Typography id="modal-description" variant="body1" sx={{ mb: 2 }}>
          Hemos enviado un correo electrónico a tu dirección de correo registrada con una contraseña temporal. Por favor, revisa tu bandeja de entrada.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleClose}
          sx={{ mt: 2 }}
        >
          Cerrar
        </Button>
      </Box>
    </Modal>
  );
};

const RecoverPassword = () => {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");


  const recoverPasswordHandle = async () => {
    const { username } = formik.values;
    console.log(formik.values);
    if (!username) {
      setErrorMsg("Email es requerido.");
      return;
    }
    setLoading(true);
    const {data} = await recoverPasswordRequest(username);
    setLoading(false);
    console.log(data);
    if (data.Type === 0) {
      setSuccess(true);
    } else {
      setErrorMsg(data.Message);
    }
  };

  const formik = useFormik({
    initialValues: { 
      username: "", 
    },
    validationSchema,
    onSubmit: recoverPasswordHandle,
  });

  return (
    <Grid container style={{ height: "100vh", margin: "0 !important" }}>
      <Grid
        container
        item
        xs={12}
        md={6}
        direction="column"
        justifyContent="center"
        alignItems="center"
        style={{ backgroundColor: theme.s10palette.S10Blueblue50 }}
      >
        <MySnackbar
          open={errorMsg !== ""}
          autoHideDuration={6000}
          msg={errorMsg}
          severity="error"
          onClose={() => setErrorMsg("")}
        />
        <Grid
          container
          direction="row"
          maxWidth="20rem"
          alignItems="center"
          rowSpacing="1rem"
          component="form"
          onSubmit={recoverPasswordHandle}
        >
          <Grid justifyContent="center" alignItems="center" alignContent="center" item xs={12} style={{ marginTop: ".5rem" }}>
            <img style={{ width: "8.75rem" }} src={s10Logo} alt="S10" />
          </Grid>
          <Typography variant="h3" style={{ marginBottom: "0.5rem" }}>
            ¡Bienvenido!
          </Typography>
          <Typography variant="h6">Portal del colaborador - Recuperar contraseña</Typography>
          <Divider
            style={{
              width: "100%",
              marginTop: "1.19rem",
              marginBottom: "1.5rem",
              color: theme.s10palette.S10Blueblue100,
            }}
          />
          <Typography variant="body1" align="left" width="100%">
            Ingresa tu correo afiliado para recuperar contraseña
          </Typography>
          <MyTextField
            id="username"
            label="Usuario"
            type="text"
            name="username"
            value={formik.values.username}
            onChange={formik.handleChange}
            error={formik.values.username.length > 3 && Boolean(formik.errors.username)}
            helperText={formik.values.username.length > 3 ? formik.errors.username : ""}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" style={{ color: theme.s10palette.S10Greygrey900 }}>
                  <LoginMailIcon />
                </InputAdornment>
              ),
            }}
          />
          <Typography variant="body2" style={{ marginTop: '10px' }}>
            <Link to="/ingresar" color="primary">
              Ingresa aquí
            </Link>
          </Typography>
          <Grid item width="20rem" style={{ marginTop: "1rem" }}>
            <Button variant="contained" type="submit" fullWidth disabled={loading}>
              Recuperar
            </Button>
          </Grid>
        </Grid>
        <PasswordRecoveryModal
          success={success}
        />
      </Grid>
      <Grid
        item
        md={6}
        sx={{ display: { xs: "none", md: "block" } }}
        style={{
          backgroundColor: theme.s10palette.S10Blueblue700,
          backgroundImage: `url(loginDefaultImage.svg)`,
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            p: 0,
          }}
        >
          <img
            src={authImage}
            alt="Ilustración auth"
            style={{
              maxWidth: '100%',
              maxHeight: '90%',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default RecoverPassword;
